<template>
  <div
    v-dragWhole
    class="scroll-content"
    :style="{ height: height + 'px' }"
    data-action="scrollContent"
  >
    <div
      v-show="showHandle"
      :style="handleStyle"
      data-action="scrollHandle"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'ScrollContent',
  props: {
    idName: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      dom: null,
      height: 0,
      top: 0,
      scrollHeight: 100,
      scrollTop: 0,
      showHandle: false,
      observer: null,
      action: '',
      mpos: null
    };
  },
  computed: {
    handleStyle() {
      const style = {};
      style.height = (this.height / this.scrollHeight) * 100 + '%';
      style.top = (this.scrollTop / this.scrollHeight) * 100 + '%';
      return style;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.idName) return;
      this.dom = document.getElementById(this.idName);
      this.dom.addEventListener('scroll', this.scrollEvent);
      this.initData();
      let observer = new MutationObserver(() => {
        this.initData();
      });
      observer.observe(this.dom, { attributes: true, attributeFilter: ['style'], childList: true });
    });
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer.takeRecords();
      this.observer = null;
    }
    this.dom.removeEventListener('scroll', this.scrollEvent);
    this.dom = null;
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    initData() {
      if (!this.dom) return
      ;({ height: this.height, top: this.top } = this.dom.getBoundingClientRect());
      this.scrollHeight = this.dom.scrollHeight;
      this.scrollTop = this.dom.scrollTop;
      if (this.height < this.scrollHeight) {
        this.showHandle = true;
      } else {
        this.showHandle = false;
      }
    },
    resize() {
      this.initData();
    },
    scrollEvent(e) {
      this.scrollTop = e.target.scrollTop;
    },
    dragDown(dis, action, e) {
      if (action === 'scrollHandle') {
        e.preventDefault();
        this.action = action;
        this.mpos = {
          val: this.scrollTop,
          y: dis.y,
          max: this.scrollHeight - this.height
        };
      }
    },
    dragMove(pos, action, e) {
      if (this.action === 'scrollHandle') {
        e.preventDefault();
        let pre = Math.round(((pos.y - this.mpos.y) / this.height) * this.scrollHeight) + this.mpos.val;
        this.scrollTop = pre > this.mpos.max ? this.mpos.max : pre <= 0 ? 0 : pre;
        this.dom.scrollTop = this.scrollTop;
      }
    },
    dragUp() {
      this.action = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.scroll-content {
  position: absolute;
  top: 0;
  left: calc(100% - 8px);
  width: 8px;
  height: 100%;
  background-color: transparent;
  z-index: 100;

  > div {
    position: absolute;
    left: 0;
    top: 0;
    width: 8px;
    border-radius: 4px;
    background-color: #d4d6dc;
  }
}
</style>
